module.exports = __webpack_public_path__ + "static/img/2027.c2440c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2027.jpg
// module id = 317
// module chunks = 0